import {z} from 'zod'

export type ProjectId = `pr-${string}`
export const ProjectId = z.string().startsWith('pr-') as z.ZodType<ProjectId>
